/* eslint-disable */
import {
  ALLIANCE_ANNOUNCEMENT_BG_URL,
  ALLIANCE_ANNOUNCEMENT_BODY_BG_URL,
  ALLIANCE_ANNOUNCEMENT_BODY_ICON_URL,
  ALLIANCE_MANAGE_CORNER_BL_URL,
  ALLIANCE_MANAGE_CORNER_BR_URL,
  ALLIANCE_MANAGE_CORNER_TL_URL,
  ALLIANCE_MANAGE_CORNER_TR_URL,
  ALLIANCE_MANAGE_ICON_DIPLOMACY_URL,
  ALLIANCE_MANAGE_ICON_LIVE_MESSAGE_URL,
  ALLIANCE_MANAGE_ICON_MANAGEMENT_URL,
  ALLIANCE_MANAGE_ICON_OVERVIEW_URL,
  ALLIANCE_MANAGE_ICON_REWARD_URL,
  ALLIANCE_MANAGE_ICON_SETTINGS_URL,
  ALLIANCE_MANAGE_ICON_TASKS_URL,
  ALLIANCE_MANAGE_ICON_TECHNOLOGY_URL,
  ALLIANCE_MANAGE_ICON_TERRITORY_URL,
  ALLIANCE_MANAGE_LEAVE_URL,
  ALLIANCE_MANAGE_LEADER_SCORE_BADGE_URL,
  ALLIANCE_MANAGE_NAVIGATION_PANEL_BG_URL,
  ALLIANCE_MANAGE_NAV_TAB_ACTIVE_BG_URL,
  ALLIANCE_MANAGE_PANEL_BG_URL,
  ALLIANCE_MANAGE_PANEL_BOTTOM_URL,
  ALLIANCE_MANAGE_PANEL_LEFT_URL,
  ALLIANCE_MANAGE_PANEL_RIGHT_URL,
  ALLIANCE_MANAGE_PANEL_TOP_URL,
  ALLIANCE_MEMBER_CARD_BORDER_ACCORD_URL,
  ALLIANCE_MEMBER_CARD_BORDER_AEGIS_URL,
  ALLIANCE_MEMBER_CARD_BORDER_LEADER_URL,
  ALLIANCE_MEMBER_CARD_BORDER_NEXUS_URL,
  ALLIANCE_MEMBER_CARD_BORDER_NORMAL_URL,
  ALLIANCE_MEMBER_CARD_BORDER_REGENT_URL,
  ALLIANCE_MEMBER_CARD_DONATE_BTN_BG_URL,
  ALLIANCE_MEMBER_CARD_KICK_BTN_BG_URL,
  ALLIANCE_MEMBER_RANK_ICONS,
  ALLIANCE_OVERVIEW_GIRL_URL,
  ALLIANCE_OVERVIEW_ICON_LEADER_URL,
  ALLIANCE_OVERVIEW_ICON_MEMBER_URL,
  ALLIANCE_OVERVIEW_ICON_SCORE_URL,
  ALLIANCE_TASK_ADD_BUTTON_BG_URL,
  ALLIANCE_TASK_CATEGORY_DIPLOMACY_URL,
  ALLIANCE_TASK_CATEGORY_TECH_URL,
  ALLIANCE_TASK_CATEGORY_WAR_URL,
  ALLIANCE_TASK_CREATE_END_BG_URL,
  ALLIANCE_TASK_CREATE_START_BG_URL,
  ALLIANCE_TASK_FINALIZE_RIBBON_BG_URL,
  ALLIANCE_TASK_HERO_PANEL_ICON_URL,
  ALLIANCE_TASK_ICON_CALENDAR_URL,
  ALLIANCE_TASK_ICON_GOVERNANCE_SCORE_URL,
  ALLIANCE_TASK_ICON_REMAINING_TIME_URL,
  ALLIANCE_TASK_ICON_WAR_URL,
  ALLIANCE_TASK_IMPACT_BG_URL,
  ALLIANCE_TECHNOLOGY_BG_URL,
  ALLIANCE_TITLE_BANNER_CENTER_URL,
  ALLIANCE_TITLE_BANNER_LEFT_CORNER_URL,
  ALLIANCE_TITLE_BANNER_LEFT_URL,
  ALLIANCE_TITLE_BANNER_RIGHT_CORNER_URL,
  ALLIANCE_TITLE_BANNER_RIGHT_URL,
  getAllianceTechnologyBuildingArtUrl,
} from '../components/alliances/allianceManageRedesignAssets'
import { ALLIANCE_TECH_CANVAS_LAYOUT } from '../components/alliances/allianceTechCanvasLayout'

const ALLIANCE_MANAGE_REDESIGN_STATIC_URLS: readonly string[] = [
  ALLIANCE_MANAGE_ICON_DIPLOMACY_URL,
  ALLIANCE_MANAGE_ICON_MANAGEMENT_URL,
  ALLIANCE_MANAGE_ICON_OVERVIEW_URL,
  ALLIANCE_MANAGE_ICON_TASKS_URL,
  ALLIANCE_TASK_HERO_PANEL_ICON_URL,
  ALLIANCE_TASK_ICON_CALENDAR_URL,
  ALLIANCE_TASK_ADD_BUTTON_BG_URL,
  ALLIANCE_TASK_ICON_WAR_URL,
  ALLIANCE_TASK_CATEGORY_WAR_URL,
  ALLIANCE_TASK_CATEGORY_DIPLOMACY_URL,
  ALLIANCE_TASK_CATEGORY_TECH_URL,
  ALLIANCE_TASK_ICON_REMAINING_TIME_URL,
  ALLIANCE_TASK_ICON_GOVERNANCE_SCORE_URL,
  ALLIANCE_TASK_CREATE_START_BG_URL,
  ALLIANCE_TASK_CREATE_END_BG_URL,
  ALLIANCE_TASK_IMPACT_BG_URL,
  ALLIANCE_TASK_FINALIZE_RIBBON_BG_URL,
  ALLIANCE_MANAGE_ICON_TECHNOLOGY_URL,
  ALLIANCE_MANAGE_ICON_SETTINGS_URL,
  ALLIANCE_MANAGE_ICON_TERRITORY_URL,
  ALLIANCE_MANAGE_ICON_LIVE_MESSAGE_URL,
  ALLIANCE_MANAGE_ICON_REWARD_URL,
  ALLIANCE_MANAGE_LEADER_SCORE_BADGE_URL,
  ALLIANCE_ANNOUNCEMENT_BG_URL,
  ALLIANCE_ANNOUNCEMENT_BODY_BG_URL,
  ALLIANCE_ANNOUNCEMENT_BODY_ICON_URL,
  ALLIANCE_MANAGE_LEAVE_URL,
  ALLIANCE_OVERVIEW_GIRL_URL,
  ALLIANCE_OVERVIEW_ICON_LEADER_URL,
  ALLIANCE_OVERVIEW_ICON_MEMBER_URL,
  ALLIANCE_OVERVIEW_ICON_SCORE_URL,
  ...Object.values(ALLIANCE_MEMBER_RANK_ICONS),
  ALLIANCE_TECHNOLOGY_BG_URL,
  ALLIANCE_MANAGE_PANEL_BG_URL,
  ALLIANCE_MANAGE_NAVIGATION_PANEL_BG_URL,
  ALLIANCE_MANAGE_NAV_TAB_ACTIVE_BG_URL,
  ALLIANCE_MANAGE_PANEL_TOP_URL,
  ALLIANCE_MANAGE_PANEL_BOTTOM_URL,
  ALLIANCE_MANAGE_PANEL_LEFT_URL,
  ALLIANCE_MANAGE_PANEL_RIGHT_URL,
  ALLIANCE_MANAGE_CORNER_TL_URL,
  ALLIANCE_MANAGE_CORNER_TR_URL,
  ALLIANCE_MANAGE_CORNER_BL_URL,
  ALLIANCE_MANAGE_CORNER_BR_URL,
  ALLIANCE_TITLE_BANNER_LEFT_CORNER_URL,
  ALLIANCE_TITLE_BANNER_LEFT_URL,
  ALLIANCE_TITLE_BANNER_CENTER_URL,
  ALLIANCE_TITLE_BANNER_RIGHT_URL,
  ALLIANCE_TITLE_BANNER_RIGHT_CORNER_URL,
  ALLIANCE_MEMBER_CARD_BORDER_LEADER_URL,
  ALLIANCE_MEMBER_CARD_BORDER_REGENT_URL,
  ALLIANCE_MEMBER_CARD_BORDER_AEGIS_URL,
  ALLIANCE_MEMBER_CARD_BORDER_ACCORD_URL,
  ALLIANCE_MEMBER_CARD_BORDER_NEXUS_URL,
  ALLIANCE_MEMBER_CARD_BORDER_NORMAL_URL,
  ALLIANCE_MEMBER_CARD_DONATE_BTN_BG_URL,
  ALLIANCE_MEMBER_CARD_KICK_BTN_BG_URL,
]

const ALLIANCE_TECH_BUILDING_ART_URLS: readonly string[] = Object.keys(ALLIANCE_TECH_CANVAS_LAYOUT).map((id) =>
  getAllianceTechnologyBuildingArtUrl(id),
)

function dedupePreserveOrder(urls: readonly string[]): string[] {
  const seen = new Set<string>()
  const out: string[] = []
  for (const u of urls) {
    if (!u || seen.has(u)) continue
    seen.add(u)
    out.push(u)
  }
  return out
}

/** Alliance manage redesign — `allianceManageRedesignAssets` + tech map building sprites (`allianceTechCanvasLayout`). */
export const ALLIANCE_MANAGE_REDESIGN_BLOB_PRELOAD_URLS: readonly string[] = dedupePreserveOrder([
  ...ALLIANCE_MANAGE_REDESIGN_STATIC_URLS,
  ...ALLIANCE_TECH_BUILDING_ART_URLS,
])
